<template>
    <div></div>
</template>
<script>

    export default {
        props: ['visible'],
        data () {
            return {
                /*
                config: {
                    imageUploadURL: '/upload_image',
                    events: {
                        'froalaEditor.initialized': function () {
                            console.log('initialized')
                        }
                    }/*,
                    toolbarButtons: ['bold', 'italic', 'underline', 'strikeThrough', 'fontFamily', 'fontSize', '|', 'table', 'ul', 'ol', '|', 'paragraphStyle', 'paragraphFormat', 'align', 'undo', 'redo', 'html']*/
                //},
                className:"modal-fade-enter-active",
                internalValue: '',
                locales: null,
                locale: 'all',
                localesLoaded: true
            }
        },
        created: function() {
            this.internalValue = this.value;

        },
        mounted: function(){
            this.locale = this.$store.state.scope.locales[0].id,
            this.locales = this.$store.state.scope.locales
        },
        methods:{
            initialize: function(){
                var self = this;
                setTimeout(function(){self.className = ""}, 100)
            },
            copy:function(original) {
                return JSON.parse(JSON.stringify(original));
            },
            close() {
                this.$emit('close');
            },
            validate(){
                this.$emit('validate');
            },
            remove(){
                let ask = confirm("Souhaitez-vous supprimer cet élément ?");
                if( ask ) {
                    this.$emit('remove');
                }
            }
        },
        watch: {
            'value'(newVal, oldVal) {
                this.internalValue = newVal
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/layouts/ModalEdit.vue